import { MY_LIFESTYLE } from '../constants';
import { LIFESTYLE } from '../constants/progressCategories';

const myLifestyleSports = {
  name: 'sports',
  category: MY_LIFESTYLE,
  progressCategory: LIFESTYLE,
  route: `/consultation/${MY_LIFESTYLE}/sports`,
  multi: true,
  title: 'In an average week, where do you workout?',
  subtitle: 'Select all that apply',
  tip: {
    title: 'Why we ask:',
    content:
      'Sweating affects your hair a lot (as you’ve no doubt experienced), as does the environment that happens in. This gives us insight into both.',
  },
  options: [
    { value: 'indoors', label: 'Indoors / gym' },
    { value: 'outdoors', label: 'Outdoors / running course' },
    { value: 'swimming_pool', label: 'Chlorine swimming pool' },
    { value: 'sea_beach', label: 'Ocean / beachside' },
    {
      value: 'none',
      label: 'None of the above, or I don’t exercise often',
      unique: true,
    },
  ],
  shouldBeIncluded: () => true,
  getInitialValue: answers => answers.profile_sports,
  getAnswers: ({ selected }) => ({ profile_sports: selected }),
};

export default myLifestyleSports;
